// Storefront companion for the OpenAI Ads Measurement Pixel.
//
// The OpenAI SDK keeps oppref in its own first-party __oppref cookie for
// browser events. This script also copies the untouched query value into a
// private Shopify cart attribute so it becomes an order note attribute and is
// available to the server-side orders/create webhook.
(function persistOpenAIAdsOppref() {
  const STORAGE_KEY = 'openai_ads_oppref';
  const CART_ATTRIBUTE = '__openai_oppref';

  function readStorage(storage) {
    try {
      return storage?.getItem(STORAGE_KEY) || null;
    } catch {
      return null;
    }
  }

  function writeStorage(storage, value) {
    try {
      storage?.setItem(STORAGE_KEY, value);
    } catch {
      // Storage can be disabled without blocking cart attribution.
    }
  }

  let oppref = null;
  try {
    oppref = new URL(window.location.href).searchParams.get('oppref');
  } catch {
    // Ignore malformed or unavailable URLs.
  }

  if (oppref) {
    writeStorage(window.sessionStorage, oppref);
    writeStorage(window.localStorage, oppref);
  } else {
    oppref = readStorage(window.sessionStorage) || readStorage(window.localStorage);
  }

  if (!oppref) return;

  const persistToCart = () => fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    credentials: 'same-origin',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { [CART_ATTRIBUTE]: oppref } }),
  }).catch(() => {
    // Attribution must never block storefront navigation or checkout.
  });

  function addAttributeToCheckoutForms() {
    if (!window.document?.querySelectorAll || !window.document?.createElement) return;
    for (const form of window.document.querySelectorAll('form[action]')) {
      let action;
      try {
        action = new URL(form.action, window.location.href).pathname;
      } catch {
        continue;
      }
      const submitsCart = /\/cart\/?$/.test(action);
      const hasCheckoutControl = form.querySelector?.('[name="checkout"]');
      if (!submitsCart && !hasCheckoutControl) continue;
      let input = form.querySelector?.(`[name="attributes[${CART_ATTRIBUTE}]"]`);
      if (!input) {
        input = window.document.createElement('input');
        input.type = 'hidden';
        input.name = `attributes[${CART_ATTRIBUTE}]`;
        form.appendChild(input);
      }
      input.value = oppref;
    }
  }

  persistToCart();
  addAttributeToCheckoutForms();

  // Reapply after initial app/cart initialization and before navigation. This
  // protects attribution when another storefront integration rewrites cart
  // attributes after the first page load.
  for (const delay of [1000, 4000]) window.setTimeout?.(persistToCart, delay);
  window.addEventListener?.('pageshow', persistToCart);
  window.document?.addEventListener?.('submit', event => {
    const form = event.target;
    if (form?.querySelector?.('[name="checkout"]')) {
      addAttributeToCheckoutForms();
      persistToCart();
    }
  }, true);

  if (window.MutationObserver && window.document?.documentElement) {
    new window.MutationObserver(addAttributeToCheckoutForms)
      .observe(window.document.documentElement, { childList: true, subtree: true });
  }
})();
